import axios from '@/api/axios'
import urls from '@/api/url'
export default {

  signIn: (formData) =>
    axios.post(urls.signIn, formData), // 登录

  getValidata: () =>
    axios.get(urls.getValidata),  // 获取验证码

  signout: (formData) =>
    axios.post(`${urls.signOut}?access_token=${formData}`), // 退出登录

  getUser: (formData) =>
    axios.post(urls.getUser, formData), // 获取用户信息

  getschemeList: (formData) =>
    axios.post(urls.schemeUrl, formData), // 中心运营 大计划列表

  downLineScheme: (formData) =>
    axios.post(urls.downLineScheme, formData), // 大计划下线

  upLineScheme: (formData) =>
    axios.post(urls.upLineScheme, formData), // 大计划下线

  getAddschemeUrl: (formData) =>
    axios.post(urls.addschemeUrl, formData), // 新建计划

  deletescheme: (formData) =>
    axios.post(urls.deletescheme, formData), // 大计划删除

  editGetById: (formData) =>
    axios.post(urls.editGetById, formData), // 编辑前查询

  getEditUpdate: (formData) =>
    axios.post(urls.editUpdate, formData), // 编辑计划

  getProfessionListUrl: (formData) =>
    axios.post(urls.professionListUrl, formData), // 专业下拉

  getOrgTypeListUrl: (formData) =>
    axios.post(urls.orgTypeListUrl, formData), // 机构类型下拉

  getRaceTypeListUrl: (formData) =>
    axios.post(urls.raceTypeListUrl, formData), // 大赛类型下拉

  getSchemePublish: (formData) =>
    axios.post(urls.schemePublish, formData), //  发布计划

  getProvinceList: (formData) =>
    axios.post(urls.provinceList, formData), // 省份下拉

  pageListPaper: (formData) =>
    axios.post(urls.pageListPaper, formData), // 试卷管理 试卷展示分页

  getSubjectList: (formData) =>
    axios.post(urls.subjectList, formData), // 科目下拉

  getSchemeUpdate: (formData) =>
    axios.post(urls.schemeUpdate, formData), // 计划编辑

  getlistPagePaper: (formData) =>
    axios.post(urls.listPagePaper, formData), // 试卷管理 添加试卷前的 分页

  addBatchPaper: (formData) =>
    axios.post(urls.addBatchPaper, formData), // 试卷管理 添加试卷

  batchDeletePaper: (formData) =>
    axios.post(urls.batchDeletePaper, formData),  // 试卷管理 批量删除试卷

  signupApplyPageList: (formData) =>
    axios.post(urls.signupApplyPageList, formData), // 中心运营 大计划 机构管理展示分页

  openSignupApply: (formData) =>
    axios.post(urls.openSignupApply, formData), // 开通机构

  closeSignupApply: (formData) =>
    axios.post(urls.closeSignupApply, formData), // 停用机构

  getPageListApply: (formData) =>
    axios.post(urls.pageListApply, formData), // 申报机构的 分页展示

  getDeclareSchemeList: (formData) =>
    axios.post(urls.declareSchemeList, formData), // 申报机构时的 大计划下拉

  getDictOrglist: (formData) =>
    axios.post(urls.dictOrglist, formData), // 申报机构时的 未被添加进 的机构

  getAddEndOrgList: (formData) =>
    axios.post(urls.addEndOrgList, formData), // 右侧已经添加的机构

  getSalerAddApply: (formData) =>
    axios.post(urls.salerAddApply, formData), // 批量添加 机构

  removeAddEndOrg: (formData) =>
    axios.post(urls.removeAddEndOrg, formData), //	批量移除已经 添加的机构

  setCommitApply: (formData) =>
    axios.post(urls.commitApply, formData), // 批量提交

  setBommitBack: (formData) =>
    axios.post(urls.commitBack, formData), // 批量删除

  deleteApply: (formData) =>
    axios.post(urls.deleteApply, formData), // 删除申报机构

  getApplyInfoById: (formData) =>
    axios.post(urls.getApplyInfoById, formData), // 编辑钱查询

  setUpdateApply: (formData) =>
    axios.post(urls.updateApply, formData), // 编辑钱查询:

  getlistApplyPage: (formData) =>
    axios.post(urls.listApplyPage, formData), // 机构申请审批

  getmMnagerApprove: (formData) =>
    axios.post(urls.managerApprove, formData), // 管理员通过申请

  getManageReject: (formData) =>
    axios.post(urls.manageReject, formData), //驳回申请

  getmanagerListAccount: (formData) =>  // 查看账号
    axios.post(urls.managerListAccount, formData),

  getmanagerListAccount2: (formData) => // 查看账号2
    axios.post(urls.managerListAccount2, formData),

  getmanagerListAccount3: (formData) => // 查看账号3
    axios.post(urls.managerListAccount3, formData),

  setResetPassword: (formData) =>
    axios.post(urls.resetPassword, formData), // 重制密码

  getUserTypeisValid: (formData) =>
    axios.post(urls.userTypeisValid, formData), // 登录后调的第一个接口获得用户的类型

  getDictOrgListPage: (formData) =>
    axios.post(urls.dictOrgListPage, formData), // 机构管理

  checkOrgName: (formData) =>
    axios.post(urls.checkOrgName, formData), // 校验名称是否重复

  updateDictOrg: (formData) =>
    axios.post(urls.updateDictOrg, formData), // 修改机构信息

  getUserList: (formData) =>
    axios.post(urls.userList, formData), // 人员管理

  getUserListUser: (formData) =>
    axios.post(urls.userListUser, formData), // 增加人员时弹框的用户列表

  getUserlistDept: (formData) =>
    axios.post(urls.userlistDept, formData), // 增加人员时弹框的机构列表

  addUserPerson: (formData) =>
    axios.post(urls.addUserPerson, formData), // 增加人员

  removeUser: (formData) =>
    axios.post(urls.removeUser, formData), // 删除人员

  getSubjectJzList: (formData) =>
    axios.post(urls.subjectJzList, formData), // 金砖加载科目列表


  getimportInsOrgList: (formData) =>
    axios.post(urls.importInsOrgList, formData),// 批量上传机构，

  getimportBatchApply: (formData) =>
    axios.post(urls.importBatchApply, formData), // 批量申请机构

  deleteOrg: (formData) =>
    axios.post(urls.deleteOrg, formData), // 删除申请机构

  addOrgList: (formData) =>
    axios.post(urls.addOrgList, formData), // 增加机构时加载不存在于报名系统的机构

  saveBathIns: (formData) =>
    axios.post(urls.saveBathIns, formData), // 勾选多条机构点击保存操作

  webApplyPassage: (formData) =>
    axios.get(urls.webApplyPassage, formData), // 官网注册审批第一个页面

  newWebApplyPassage: (formData) =>
    axios.post(urls.newWebApplyPassage, formData), // 新的官网注册审批第一个页面

  getOrgQueryApplyOrg: (formData) =>
    axios.post(urls.getOrgQueryApplyOrg, formData), // 官网注册审批第二个页面

  getNewOrgQueryApplyOrg: (formData) =>
    axios.post(urls.getNewOrgQueryApplyOrg, formData), // 新的 -官网注册审批第二个页面


  setApplyPassorglist: (formData) =>
    axios.post(urls.setApplyPassorglist, formData), // 批量通过 = 批量驳回 （弃用）

  setApplyPassorglist2: (formData) =>
    axios.post(urls.setApplyPassorglist2, formData), // 批量通过

  setApplyRejectlist: (formData) =>
    axios.post(urls.setApplyRejectlist, formData), // 批量通过

  setApplyRegister2: (formData) =>
    axios.post(urls.setApplyRegister2, formData), // 单个审核

  openAndClosePlan: (formData) =>
    axios.get(`${urls.openAndClosePlan}/${formData.status}/${formData.sysType}`), // 开启关闭

  getMatchtypelist: (formData) =>
    axios.post(urls.getMatchtypelist, formData), // 报名官网List

  getProfesionlist: () =>
    axios.get(urls.getProfesionlist), // 报名官网 - 专业列表

  getPlanlist: (formData) =>
    axios.get(`${urls.getplanlist}/${formData.professionId}`), // 计划列表展示

  getpassagelist: (formData) =>
    axios.post(urls.getpassagelist, formData), // 赛项信息

  saveUpdateByid: (formData) =>
    axios.post(urls.saveUpdateByid, formData), // 报名官网编辑

  getApplyInterlist: (formData) =>
    axios.post(urls.getApplyInterlist, formData), // 注册机构查看

  getApplyEnrollorg: (formData) =>
    axios.post(urls.getApplyEnrollorg, formData), // 运营而能源信息查看（弃用）

  getTeamPageShow: (formData) =>
    axios.post(urls.getTeamPageShow, formData), // 运营而能源信息查看2

  getProvinceList2: (formData) =>
    axios.get(urls.getProvinceList2, formData), // 省份下拉2

  getAttachList: (formData) =>
    axios.post(urls.getAttachList, formData), // 附件列表

  checkRegisterStatus: (formData) => 
    axios.post(urls.checkRegisterStatus, formData), // 获取机构状态

  getExport: (formData) => 
    axios.get(`${urls.getExport}/${formData.channelId}/${formData.batchId}/${formData.groupId}/${formData.status}`, {responseType:'blob'}),  // 导出机构申报状态表status= 1- 导出机构申报明细表 status= 2

  getGroupList: (formData) => 
    axios.post(urls.getGroupList, formData), // 组别列表
}

